import React from "react";
import { Button, Tag } from "antd";
import DynamicTable from "../../../components/DynamicTable";
import { rupees, date } from "../formatters";

function CampaignsTable({ data, edit }) {
  return (
    <>
      <DynamicTable
        showAction={false}
        rowKey="id"
        dataSource={data.campaigns}
        scroll={{
          x: 1000,
        }}
        columns={[
          {
            title: "Name",
            dataIndex: "name",
          },
          {
            title: "Campus",
            dataIndex: "campus_id",
          },
          {
            title: "Status",
            dataIndex: "status",
            render: (x) => <Tag>{x}</Tag>,
          },
          {
            title: "Budget",
            dataIndex: "budget_paise",
            render: rupees,
          },
          {
            title: "Allocated / reserved",
            dataIndex: "allocated_paise",
            render: rupees,
          },
          {
            title: "Starts",
            dataIndex: "starts_at",
            render: date,
          },
          {
            title: "Ends",
            dataIndex: "ends_at",
            render: date,
          },
          {
            title: "",
            dataIndex: "action",
            render: (_, row) => (
              <Button onClick={() => edit(row)}>Manage</Button>
            ),
          },
        ]}
      />
    </>
  );
}
export default CampaignsTable;
